import React from "react";
import { CarouselImages } from "@prima-afp/prima-ui-design-system/dist/ui-components";
import { IlluminatedPlace, FocusedFace, DontMove} from '../resources/index';

const VALIDATION_INSTRUCTIONS_LIST = [
  { 
    text: <span><strong>Busca un lugar iluminado</strong></span>, 
    icon: IlluminatedPlace 
  },
  { 
    text: <span><strong>Mantente centrado</strong></span>, 
    icon: FocusedFace 
  },
  { 
    text: <span><strong>No te muevas </strong></span>, 
    icon: DontMove 
  },
];


const InstructionsList = ({enableArrows=true}) => {
  return (
    <div className="tw-relative tw-m-auto">
      <CarouselImages
        content={VALIDATION_INSTRUCTIONS_LIST.map(({ text, icon })=>({
            title: text,
            url: icon
          }))
        }
        height="300px"
        options={{
          enableArrows,
          enableTextBody: false,
          enableTitle: true,
          staticTextContent: false,
          autoplay: true,
          imageHeight:"190px"
        }}
        variant="default"
        width="270px"
      />
    </div>
  );
};

const StartValidationInstructions = () => {
  return (
    <div>
      <InstructionsList />
    </div>
  );
};

export default StartValidationInstructions;
